interface Folder {
  name: string;
  parent?: Folder | null;
}

function getFolderPath(folder: Folder): string {
  let filePath = `${folder.name}`;
  while (folder.parent != null) {
    filePath = `${folder.parent.name}/${filePath}`;
    folder = folder.parent;
  }
  return filePath;
}

export default getFolderPath;
